<template>
  <div class="countdown">
    <div v-if="msTime.show" class="countdown-text">
      <span class="countdown-tip-text">{{tipText}}</span>
      <!-- <span v-if="!tipShow">{{tipTextEnd}}:</span> -->
      <div class="timer-count">
        <span class="timer-count-day" v-if="msTime.day>0"><span>{{msTime.day}}</span><i>{{dayTxt}}</i></span>
        <div class="timer-count-content">
          <span>{{msTime.hour}}</span><i>{{hourTxt}}</i>
          <span>{{msTime.minutes}}</span><i>{{minutesTxt}}</i>
          <span>{{msTime.seconds}}</span><i>{{secondsTxt}}</i>
        </div>
       
      </div>
    </div>
    <!--<p v-if="!msTime.show">{{endText}}</p>-->
  </div>
</template>
<script>
const THREEHOURS = 3*60*60*1000;
let timer = null;
  export default {
    replace: true,
    data () {
      return {
        tipShow: true,
        msTime: {			//倒计时数值
          show: false,		//倒计时状态
          day: '',			//天
          hour: '',		//小时
          minutes: '',		//分钟
          seconds: ''		//秒
        },
        star: '',			//活动开始时间
        end: '',				//活动结束时间
        current: '',         //当前时间
        timeRemaining:this.timeDistance,
        interval:1000,
        count:0,
        startTime:new Date().getTime()
      }
    },
    watch: {
      currentTime () {
        this.gogogo();
      },
      isActive () {
        this.gogogo();
      },
      isClear(val){
        if(val){
          this.clearTimer()
        }
      },
      timeDistance(newVal){
        this.timeRemaining = newVal;
        this.gogogo();
      }
    },
    props: {
      isClear:{
          type:Boolean,
          default: false
      },
      isActive:{
          type:Number,
          default: 0
      },
      //距离开始提示文字
      tipText: {
        type: String,
        default: '距离开始'
      },
      //距离结束提示文字
      tipTextEnd: {
        type: String,
        default: '距离结束'
      },
      //时间控件ID
      id: {
        type: String,
        default: '1'
      },
      //当前时间
      currentTime: {
        type: Number
      },
      // 活动开始时间
      // startTime: {
      //   type: Number
      // },
      // 活动结束时间
      endTime: {
        type: Number
      },
      // 倒计时结束显示文本
      endText: {
        type: String,
        default: '已结束'
      },
      //自定义显示文字:天
      dayTxt: {
        type: String,
        default: ':'
      },
      //自定义显示文字:时
      hourTxt: {
        type: String,
        default: ':'
      },
      //自定义显示文字:分
      minutesTxt: {
        type: String,
        default: ':'
      },
      secondsTxt: {
        type: String,
        default: ''
      },
      //是否开启秒表倒计，未完成
      secondsFixed: {
        type: Boolean,
        default: false
      },
      // 剩余时间
      timeDistance:{
        type: Number
      },
      isShowCountDown:{
        type:Boolean,
        default:false
      }
      
    },
    mounted () {
      this.gogogo();
    },
    methods: {
      clearTimer(){
        if(this.isClear){
            window.clearInterval(timer)
            // this.gogogo();
        }
      },
      gogogo: function () {
        /**
         * 结束时间大于当前并且开始时间小于当前时间，执行活动开始倒计时
         */
        this.msTime.show = true;
        this.$emit('start_callback', this.msTime.show);
        timer = setTimeout(() => {
          this.runTime(this.timeRemaining, this.end_message, true)
        }, 1);
      },
      runTime (timeRemaining,callFun) {
        this.msTime.show = false;
        this.count++
        const offset = new Date().getTime() - (this.startTime + this.count * this.interval) // A
        let nextTime = this.interval - offset
        if (nextTime < 0) { 
            nextTime = 0 
        }
        let msTime = this.msTime;
        let timeDistance = timeRemaining;
        timeDistance-=this.interval
        // 剩余时间小于三个小时
        if(timeDistance < THREEHOURS){
          this.$emit('update:isShowCountDown',true)
        }
        if (timeDistance > 0) {
          msTime.day = Math.floor(timeDistance / 86400000);
          timeDistance -= msTime.day * 86400000;
          msTime.hour = Math.floor(timeDistance / 3600000);
          timeDistance -= msTime.hour * 3600000;
          msTime.minutes = Math.floor(timeDistance / 60000);
          timeDistance -= msTime.minutes * 60000;
          msTime.seconds = Math.floor(timeDistance / 1000).toFixed(0);
          timeDistance -= msTime.seconds * 1000;
          if (msTime.day < 10) {
            msTime.day = "0" + msTime.day;
          }
          if (msTime.hour < 10) {
            msTime.hour = "0" + msTime.hour;
          }
          if (msTime.minutes < 10) {
            msTime.minutes = "0" + msTime.minutes;
          }
          if (msTime.seconds < 10) {
            msTime.seconds = "0" + msTime.seconds;
          }
          // console.log(`误差：${offset} ms，下一次执行：${nextTime} ms 后，离活动开始还有：${msTime.seconds} s`)
          this.msTime.show = true;
          timer = setTimeout(() => {
            this.runTime(this.timeRemaining-=1000 ,callFun);
          }, nextTime)
        }else{
          callFun()
          window.clearInterval(timer)
          this.$emit('update:isShowCountDown',false)
          this.$emit('countOver',)
        }
      },
      // start_message () {
      //   this.$set(this, 'tipShow', false);
      //   this.$emit('start_callback', this.msTime.show);
      //   timer = setTimeout(() => {
      //     this.runTime(this.end, this.star, this.end_message, true)
      //   }, 1);
      // },
      end_message(){
        this.msTime.show = false;
        if (this.currentTime <= 0) {
          return;
        }
        this.$emit('end_callback', this.msTime.show);
      }
    }
  }
</script>
<style scoped lang='less'>
  .countdown{
    color:#fff;
    font-size: 24px;
    text-align: center;
    .countdown-text{
      display: flex;
      padding: 0;
      margin: 0;
      align-items: center;
      justify-content: center;
    }
    .timer-count-day{
      margin-right:6px;
    }
    .countdown-tip-text{
      line-height: 30px;
      margin-right:8px;
    }
    .timer-count-content{
      width: 100px;
    }
    .timer-count{
      text-align: left;
      display: flex;
    }
    i{
      font-style: normal;
    }
  }
</style>
 